import { getSpotConfig } from '@host-panel/request/config';

export function getConversationSurveyConfig(spotId: string) {
  return getSpotConfig(spotId, ['tenant.conversation-survey.enabled']);
}
